import axios from "axios";

const BASE_ROUTE = '/api/servers';

export interface ServerBaseDTO {
    name: string;
    ipV4: string;
    ipV6: string;
    uri: string;
    domain: string;
    note: string;
    creationDate: string;
    updateDate: string;
    enabled: boolean;
}

export interface ServerDTO extends ServerBaseDTO {
    oid: string;
}

interface GetServersRequest {
    params: {
        name?: string;
        ipV4?: string;
        ipV6?: string;
        domain?: string;
        note?: string;
        uri?: string;
        pageSize: number;
        pageNumber: number;
        orderByPropertyName: string;
        orderByDescending: boolean;
    }
}
interface GetServersResponse {
    totalResultNumber: number;
    servers: ServerDTO[];
}

/**
 * Get the list of servers with optional filters and pagination
 * @param {GetServersRequest} request - The request object containing the filters and pagination options
 */
export const GetServers = (request: GetServersRequest) =>
    axios.request<GetServersResponse>({
        method: 'GET',
        url: `${BASE_ROUTE}`,
        ...request
    });